import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message, SelectItem } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { PlanoContaGrupo } from 'src/app/admihair/api/dto/plano-conta-grupo';
import { PlanoContaMatriz } from 'src/app/admihair/api/dto/plano-conta-matriz';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PlanoContaGrupoService } from 'src/app/admihair/service/plano-conta-grupo.service';
import { PlanoContaMatrizService } from 'src/app/admihair/service/plano-conta-matriz.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-plano-conta-matriz-inserir',
  templateUrl: './plano-contas-matriz-inserir.component.html',
  styleUrls: ['./plano-contas-matriz-inserir.component.scss']
})
export class PlanoContaMatrizInserirComponent implements OnInit {

  messages: Message[] = [{ severity: 'success', summary: 'Sucesso', detail: 'Cliente salvo' }]; 
  empresaSelecionada?: Empresa;
  messagemVisivel: boolean = false;
  planosContaGrupos: PlanoContaGrupo[] = [];
  prioridades: SelectItem[] = [{label: 'SIM', value: 1}, {label: 'NÃO', value: 0}];
  dadosDre: string[] = ['CUSTOS VARIAVEIS', 'CUSTOS FIXOS', 'RECEITAS', 'NÃO PRESENTE'];
  utilizacoes: string[] = ['FOLHA DE PAGAMENTO', 'DESPESA', 'FOLHA/DESPESA', 'NÃO APLICADO' ];
  referenciasFolha: string[] = ['CREDITO', 'DESCONTO', 'NÃO APLICADO' ];
  progressoRequisicao: boolean = false;
  configuravel: boolean = false;
  grupoSelecionado?: PlanoContaGrupo;

  constructor(private utilStorageService: UtilStorageService,
    private planoContaMatrizService: PlanoContaMatrizService,
    private planoContaGrupoService: PlanoContaGrupoService,
    private erroService: ErroService) { }

  @ViewChild('f') form?: NgForm;
  value?: string;

  ngOnInit(): void {
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.listarPlanosContaGrupos();
  }

  salvar(){
    this.progressoRequisicao = true;
    const planoContaMatriz: PlanoContaMatriz = this.form?.form.value;
    planoContaMatriz.configuravel = planoContaMatriz.configuravel || false;
    this.planoContaMatrizService.salvar(planoContaMatriz).subscribe({
      next: (data: PlanoContaMatriz) => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.limparFormulario();
        this.rolarTela();
        
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      }
    });
    
  }

  listarPlanosContaGrupos(){
    this.planoContaGrupoService.listarTodos().subscribe({
      next: (data: PlanoContaGrupo[]) => {
        this.planosContaGrupos = data;
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  limparFormulario(){
    this.form?.reset(); 
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
